export enum SLOT_TYPE {
  IMAGE = 1,
  VIDEO = 2,
  AUDIO = 3,
  COVER_PHOTO = 4,
  TEXT = 5,
  TRIBUTE_VIDEO = 6,
  PLAYLIST = 7,
  TEXT_OVERLAY = 8
}
